import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faGaugeSimpleHigh,
  faCopyright,
  faFilePdf,
  faList,
  faListCheck,
  faTag,
  faPalette
} from '@fortawesome/free-solid-svg-icons';
import moment from 'moment';
import EditableImage from '../EditableImage';
import EditableDifficulty from '../EditableDifficulty';
import EditableLicense from '../EditableLicense';
import EditableTags from '../EditableTags';
import EditableTextArea from '../EditableTextArea';

const GuideMetadata = ({
    isEditable,
    data,
    project,
    guide,
    updateState,
    getProgress,
    onExportGuide,
    config,
    markdownComponents,
    markdownRemarkPlugins,
    bomAutocompleteCatalog,
    guideAutocompleteCatalog,
    onCreateBomItem
  }) => {
  return (
    <div className="row">
        <div className="col-12 col-md-4 order-1 order-md-1">
            <div className="row">
            <EditableImage editable={isEditable()} value={data.guide.mainImage} index={0} onValueChange={updateState} path={'guide.mainImage'} multiple={false} uploadURL={`/api/v1/projects/${project}/guides/${guide}/upload`}/>
            </div>
        </div>
        <div className="col-12 col-md-8 order-2 order-md-2">
            <ul className="list-group">
                <li className="list-group-item">
                    <div className="guide-prop" style={{display: 'inline'}}>
                        <FontAwesomeIcon icon={faGaugeSimpleHigh}/> Difficulty: </div><div style={{display: 'inline'}}><EditableDifficulty editable={isEditable()} name='difficulty' contentStyle= {{}} editStyle={{}} value={data.guide.difficulty} index={0} onValueChange={updateState} path={'guide.difficulty'}/>
                    </div>
                </li>
                <li className="list-group-item">
                    <div className="guide-prop"style={{display: 'inline'}}>
                        <FontAwesomeIcon icon={faList}/> Steps: </div><div style={{display: 'inline'}}> {data.guide.steps?.length || 0}
                    </div>
                </li>
                <li className="list-group-item">
                    <div className="guide-prop"style={{display: 'inline'}}>
                        <FontAwesomeIcon icon={faListCheck}/> Progress: </div><div style={{display: 'inline'}}> {getProgress()}
                    </div>
                </li>

                <li className="list-group-item">
                    <div className="guide-prop" style={{display: 'inline'}}>
                        <FontAwesomeIcon icon={faFilePdf}/> Export: </div>
                    <div style={{display: 'inline'}}>
                        <button type="button" className="btn btn-link p-0 align-baseline text-decoration-none" onClick={() => onExportGuide && onExportGuide()}>
                          Download PDF
                        </button>
                    </div>
                </li>

                {(isEditable() || data.guide.tags.length > 0) && (
                    <li className="list-group-item">
                        <div className="guide-prop"style={{display: 'inline'}}>
                            <FontAwesomeIcon icon={faTag}/> Tags: </div><div style={{display: 'inline'}}><EditableTags editable={isEditable()} name='tags' editStyle={{}} value={data.guide.tags} index={0} onValueChange={updateState} path={'guide.tags'} linkPrefix={`${config.prefixPath}/projects/${data.project.slugURL}`}/>
                        </div>
                    </li>
                )}

                 <li className="list-group-item">
                    <div className="guide-prop" style={{display: 'inline'}}>
                        <FontAwesomeIcon icon={faCopyright}/> License: </div><div style={{display: 'inline'}}><EditableLicense editable={isEditable()} name='license' contentStyle= {{}} editStyle={{}} value={data.guide.license} index={0} onValueChange={updateState} path={'guide.license'}/>
                    </div>
                </li>

                {(isEditable() || data.guide.whatyouneed) && (
                    <li className="list-group-item">
                        <div className="guide-prop"><FontAwesomeIcon icon={faPalette}/> What you need:</div><div><EditableTextArea editable={isEditable()} name='guidewhatyouneed' contentStyle= {{border: '1px solid #c3c3c3', borderRadius: 5, margin: 6, padding: 10}} editStyle={{width: '100%', height:100}} value={data.guide.whatyouneed} index={0} onValueChange={updateState} path={'guide.whatyouneed'} markdownComponents={markdownComponents} markdownRemarkPlugins={markdownRemarkPlugins} bomAutocompleteCatalog={bomAutocompleteCatalog} guideAutocompleteCatalog={guideAutocompleteCatalog} onCreateBomItem={onCreateBomItem}/>
                        </div>
                    </li>
                )}
            </ul>
            <small style={{float: 'right'}}>Last updated {moment(data.guide.updateDate).fromNow()}.</small>
        </div>
    </div>
  );
}

export default GuideMetadata;
